export const FISCHERTEACHES = [
{
  id: 1,
  name: 'Position 1',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Observe this position; then decide whether the Black King can capture the checking White piece.',
  diagrams:{
    0:'7k/6pQ/8/5B2/8/8/8/4K3'
  },
  comments:{
    0:'The White Queen is giving check. The Black King:',
    1:' The Queen is protected by the Bishop; therefore the King cannot capture. In fact, the King has no safe place to move to. So Black is checkmated.'
  },
  radioButtons:{
    0: 'can capture',
    1: 'cannot capture'
  },
  answer: '1',
  solution:
  [

  ]
},
{
  id: 2,
  name: 'Position 2',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Again, observe this position; then decide whether the Black King can capture the checking White piece.',
  diagrams:{
    0:'k7/Q7/8/8/2B5/8/8/4K3'
  },
  comments:{
    0:'The White Queen is giving check. The Black King:',
    1:' The Bishop is not protecting the Queen.'
  },
  radioButtons:{
    0: 'can capture',
    1: 'cannot capture'
  },
  answer: '0',
  solution:
  [

  ]
},
{
  id: 3,
  name: 'Position 3',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Observe this position; then decide whether the Black King can capture the checking White piece.',
  diagrams:{
    0:'6Rk/7p/8/5N2/8/8/8/6K1'
  },
  comments:{
    0:'Black King:'
  },
  radioButtons:{
    0: 'can capture checking White Rook',
    1: 'cannot capture checking White Rook'
  },
  answer: '0',
  solution:
  [

  ]
},
{
  id: 4,
  name: 'Position 4',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Observe this position; then decide whether the Black King can capture the checking White piece.',
  diagrams:{
    0:'6Rk/4N2p/8/8/8/8/8/6K1'
  },
  comments:{
    0:'Black King:',
    1:' The Rook is protected by the Knight.'
  },
  radioButtons:{
    0: 'can capture checking White Rook',
    1: 'cannot capture checking White Rook'
  },
  answer: '1',
  solution:
  [

  ]
},
{
  id: 5,
  name: 'Position 5',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Observe this position; then decide whether the Black King can capture the checking White piece.',
  diagrams:{
    0:'R7/kp6/1p6/8/8/8/1K6/8'
  },
  comments:{
    0:'Black King:'
  },
  radioButtons:{
    0: 'can capture checking White Rook',
    1: 'cannot capture checking White Rook'
  },
  answer: '0',
  solution:
  [

  ]
},
{
  id: 6,
  name: 'Position 6',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Observe this position; then decide whether the Black King can capture the checking White piece.',
  diagrams:{
    0:'k1R5/pp6/8/8/8/4K3/8/8'
  },
  comments:{
    0:'Black King:'
  },
  radioButtons:{
    0: 'can capture checking White Rook',
    1: 'cannot capture checking White Rook'
  },
  answer: '1',
  solution:
  [

  ]
},
{
  id: 7,
  name: 'Position 7',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Now you decide what Black can do in this position.',
  diagrams:{
    0:'7k/7p/8/3B4/3B4/6K1/8/8'
  },
  comments:{
    0:'Black King:',
    1:' Black is mated. The Bishops team up powerfully here.'
  },
  radioButtons:{
    0: 'can capture its attacker',
    1: 'can flee',
    2: 'can do neither'
  },
  answer: '2',
  solution:
  [

  ]
},
{
  id: 8,
  name: 'Position 8',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Again, observe the position and decide what the Black King can do.',
  diagrams:{
    0:'4k2q/2pp1Q2/8/1b2N3/p7/8/3P1PP1/4K3'
  },
  comments:{
    0:'Black King:',
    1:' One square to the left. Work it out.'
  },
  radioButtons:{
    0: 'can capture attacker',
    1: 'can flee',
    2: 'can do neither'
  },
  answer: '1',
  solution:
  [

  ]
},
{
  id: 9,
  name: 'Position 9',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'',
  diagrams:{
    0:'4R1k1/6p1/6Pp/8/8/8/6K1/8'
  },
  comments:{
    0:'Black King:',
    1:' White\'s pawn stops Black\'s King from fleeing.'
  },
  radioButtons:{
    0: 'can capture attacker',
    1: 'can flee',
    2: 'can do neither'
  },
  answer: '2',
  solution:
  [

  ]
},
{
  id: 10,
  name: 'Position 10',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'',
  diagrams:{
    0:'7k/4N1pR/8/8/8/8/3K4/8'
  },
  comments:{
    0:'Black King:',
    1:''
  },
  radioButtons:{
    0: 'can capture attacker',
    1: 'can flee',
    2: 'can do neither'
  },
  answer: '0',
  solution:
  [

  ]
},
{
  id: 11,
  name: 'Position 11',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'',
  diagrams:{
    0:'rk6/1pP5/1P2Q3/8/8/8/8/7K'
  },
  comments:{
    0:'Black King:',
    1:' Black is mated'
  },
  radioButtons:{
    0: 'can capture attacker',
    1: 'can flee',
    2: 'can do neither'
  },
  answer: '2',
  solution:
  [

  ]
},
{
  id: 12,
  name: 'Position 12',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'',
  diagrams:{
    0:'5Rk1/6pp/3Q4/8/8/8/8/61K'
  },
  comments:{
    0:'Black King:',
    1:' Checking Rook is protected by the Queen, Black is mated'
  },
  radioButtons:{
    0: 'can capture attacker',
    1: 'can flee',
    2: 'can do neither'
  },
  answer: '2',
  solution:
  [

  ]
},
{
  id: 13,
  name: 'Position 13',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'',
  diagrams:{
    0:'Q2k4/8/2P5/1BK5/8/8/8/8',
    1:'Q7/2k5/2P5/1BK5/8/8/8/8'
  },
  comments:{
    0:'Move the Black King to the one square to which Black can flee:',
    1:' '
  },
  radioButtons:{

  },
  answer: '',
  solution:
  [
    {
      startrow:'1',
      startcol:'4',
      endrow:'2',
      endcol:'3'
    }
  ]
},
{
  id: 14,
  name: 'Position 14',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'',
  diagrams:{
    0:'6k1/8/4KN1P/8/8/B7/8/8',
    1:'7k/8/4KN1P/8/8/B7/8/8'
  },
  comments:{
    0:'Again move the Black King to the flight square:',
    1:' '
  },
  radioButtons:{

  },
  answer: '',
  solution:
  [
    {
      startrow:'1',
      startcol:'7',
      endrow:'1',
      endcol:'8'
    }
  ]
},
{
  id: 15,
  name: 'Position 15',
  featured: true,
  flip: false,
  image: '/assets/images/John1.png',
  description:'Here\'s a common position in which Black appears to be checkmated. Actually he can escape, but in a slightly different way from what you\'ve been accustomed to.',
  diagrams:{
      0:'8/8/8/2K4k/6R1/8/8/7Q',
      1:'8/8/8/2K6/6k1/8/8/7Q'
    },
  comments:{
    0:'Make a move to show how Black\'s King gets out of check:',
    1:' '
  },
  radioButtons:{

  },
  answer: '',
  solution:
  [
    {
      startrow:'4',
      startcol:'8',
      endrow:'5',
      endcol:'7'
    }
  ]
}
];
